import React from 'react'
import httpService from '../api-services/httpService';
import { toast } from 'react-toastify';

const AddQuestions = () => {

    const totalData = [];

    const handleAddQuestion = async () => {
        try {
            await Promise.all(
                totalData.map(async (payload, i) => {
                    const res = await httpService.post(`/questions/addQuestion`, payload);
                    console.log(res, i);
                })
            );

            console.log('Done');
            toast.success(totalData.length);
        } catch (error) {
            console.error('Error:', error);
        }
    };

    return (
        <div>
            <button onClick={handleAddQuestion}>Add {totalData.length} Questions</button>
        </div>
    )
}

export default AddQuestions

